import { baseGrtURL } from '../../httpService/API';
import { hMacAjax } from '../../httpService';
import { aiAPI, userCenterAPI } from '../../httpService/serviceApi';
import { getUserId } from '@/utils/Page';
export const url = {
    sceneDetail: `${userCenterAPI}/open/agent/ability/scene`,
    status: `${aiAPI}/case_simulation/status`,
    answerSheet: `${aiAPI}/case_simulation/answer`,
    content: `${aiAPI}/case_simulation/simulation`,
    progress: `${aiAPI}/case_simulation/simulation`,
    restart: `${aiAPI}/case_simulation/answer/restart`,
    download: `${aiAPI}/case_simulation/review_report`,
    regenerate: `${aiAPI}/case_simulation/session/regenerate`,
    caseDetail: `${aiAPI}/case_simulation/session/card`
};
const getLoginIdHeaders = () => {
    return { headers: { user: JSON.stringify({ loginId: getUserId(true) }) } };
};
// export const downloadReportUrl = `${url.download}/${id}/download`;
export function handleDownloadReport(id) {
    // window.open(`${url.download}/${id}/download`);
    window.location.href = `${url.download}/${id}/download`;
    // return hMacAjax.get(`${url.download}/${id}/download`);
}
//
export function handleCaseDetail(runtime_session_id) {
    return hMacAjax.get(url.caseDetail + '/' + runtime_session_id, {}, getLoginIdHeaders());
}
//获取场景详情
export function handleSceneDetail(id) {
    return hMacAjax.get(url.sceneDetail + '/' + id);
}
//查询任务状态
export function handleTaskStatus(runtime_session_id) {
    return hMacAjax.get(url.status + '/' + runtime_session_id);
}

//提交答题内容
export function handleSubmitAnswerSheet(data) {
    return hMacAjax.post(url.answerSheet, data, getLoginIdHeaders());
}
//获取内容
export function handleCaseAllData(runtime_session_id) {
    return hMacAjax.get(url.content + '/' + runtime_session_id, {}, getLoginIdHeaders());
}
//查询场景进度--当前进行到哪一步---刷新页面时使用
export function handleSceneProgress(runtime_session_id) {
    return hMacAjax.get(`${url.progress}/${runtime_session_id}/progress`, {}, getLoginIdHeaders());
}
//重新开始
export function handleRestart(runtime_session_id) {
    return hMacAjax.post(`${url.restart}/${runtime_session_id}`, {}, getLoginIdHeaders());
}
//重新生成卡片
export function handleRegenerate(data) {
    return hMacAjax.post(url.regenerate, data, {}, getLoginIdHeaders());
}
